/**
 * URLs de exploradores de blocos por chainId (hex ou decimal).
 * Retorna a URL da transação para o usuário abrir no explorador.
 */
const EXPLORER_BY_CHAIN = {
  '0x1': 'https://etherscan.io',
  1: 'https://etherscan.io',
  '0x89': 'https://polygonscan.com',
  137: 'https://polygonscan.com',
  '0xa4b1': 'https://arbiscan.io',
  42161: 'https://arbiscan.io',
  '0x2105': 'https://basescan.org',
  8453: 'https://basescan.org',
  '0x14a34': 'https://sepolia.basescan.org',
  84532: 'https://sepolia.basescan.org',
  '0xaa36a7': 'https://sepolia.etherscan.io',
  11155111: 'https://sepolia.etherscan.io',
};

/**
 * Retorna a URL da transação no explorador de blocos da rede.
 * @param {string|number} chainId - ID da rede (hex '0x14a34' ou decimal 84532)
 * @param {string} txHash - Hash da transação (com ou sem 0x)
 * @returns {string} URL completa ou '' se rede não mapeada
 */
export function getBlockExplorerTxUrl(chainId, txHash) {
  if (!txHash || chainId === undefined || chainId === null) return '';
  const num = typeof chainId === 'string' && chainId.startsWith('0x') ? null : Number(chainId);
  const hex = typeof chainId === 'string' && chainId.startsWith('0x') ? chainId : (num !== null && !Number.isNaN(num) ? `0x${num.toString(16)}` : null);
  const base = EXPLORER_BY_CHAIN[chainId] ?? EXPLORER_BY_CHAIN[hex] ?? (num != null && !Number.isNaN(num) ? EXPLORER_BY_CHAIN[num] : null);
  if (!base) return '';
  const hash = txHash.startsWith('0x') ? txHash : `0x${txHash}`;
  return `${base}/tx/${hash}`;
}
